import { methodTypeToIconMap, TwoFAType } from '../../domain/two-factor';
import { TwoFactorService } from '../../services/two-factor.service';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { MemoizeLast } from '@ppl/utils/memoize.utils';


@Component({
    selector: 'ppl-two-factor-method-type-selector-dropdown',
    templateUrl: './two-factor-method-type-selector-dropdown.component.html',
    styleUrls: ['./two-factor-method-type-selector-dropdown.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TwoFactorMethodTypeSelectorDropdownComponent {

  @Input() value: TwoFAType;
  @Input() types: TwoFAType[];

  @Output() valueChange = new EventEmitter<TwoFAType>();

  @MemoizeLast<TwoFactorMethodTypeSelectorDropdownComponent>(['types'])
  get options(): TwoFactorMethodTypeSelectorDropdownOption[] {
    return this.types.map(type => {
      return this.createSetupMethodDropdownOption(type);
    });
  }

  constructor(
    private twoFactorService: TwoFactorService
  ) { }

  createSetupMethodDropdownOption(methodType: TwoFAType): TwoFactorMethodTypeSelectorDropdownOption {
    return {
      id: methodType,
      icon: methodTypeToIconMap[methodType],
      label: this.twoFactorService.getMethodName(methodType)
    };
  }
}

export interface TwoFactorMethodTypeSelectorDropdownOption {
  id: TwoFAType;
  label: string;
  icon: string;
}
